/****************************************************************************************************/
/* Module Imports */
/****************************************************************************************************/

require("./mobile-menu.js");
require('jquery-lazy');
//require('jquery-backstretch');
//require('jquery-hoverintent');
require("waypoints/lib/jquery.waypoints.js");
require("waypoints/lib/shortcuts/sticky.js");
require("jquery-ui/ui/unique-id.js");
require("jquery-ui/ui/focusable.js");
require("jquery-ui/ui/tabbable");
require("jquery-ui/ui/scroll-parent.js");
require("jquery-ui/ui/scroll-parent.js");
var popup = require("jquery-popup-overlay");
import { Splide } from '@splidejs/splide';
import { Grid } from '@splidejs/splide-extension-grid';
require('@splidejs/splide/dist/css/splide.min.css');
window.Splide = Splide; // make splide available to widget scripts

import AOS from 'aos';
require('aos/dist/aos.css');
window.AOS = AOS; // make aos available to widget scripts
//import counterUp from 'counterup2';

// set some JS events to new "passive" mode (disabled due to Page Editor issues)
//require('default-passive-events');

// Polyfill for the :focus-visible classs/pseudo
//require('focus-visible');

/****************************************************************************************************/
/* Global Vars */
/****************************************************************************************************/

window.ww; // window width
window.wh; // window width
window.hh;
window.selectedClassName = 'selected'; // the selected class name for menu items
window.menuOpenClassName = 'open'; // the class that defines the open state of the menu
window.fadeInSpeed = 50; // the fade in transition speed
window.fadeOutSpeed = 75; // the fade out transition speed
window.navMouseOutDelay = 600; // the delay before the nav disappears on mouseout
window.mouseOutTimer; // the MouseOut timeout timer 
window.is_responsive = false;
window.lastScrollTop = 0; // used for tracking scroll position and direction
window.scrollDirection = "down"; // default
window.st = window.pageYOffset || document.documentElement.scrollTop;
var $header = $("#header");
function refreshScrollData() {
  // Gets the scrollTop and direction and updates the global variables accordingly
  window.st = window.pageYOffset || document.documentElement.scrollTop;
  if (window.st > lastScrollTop) {
    window.scrollDirection = "down";
  } else {
    window.scrollDirection = "up";
  }
  lastScrollTop = window.st <= 0 ? 0 : window.st; // For Mobile or negative scrolling
}
function refreshDimensions() {
  // update calculated dimensions (to be used on resize events, or anytime a manual refresh is required)
  window.ww = document.documentElement.clientWidth; //$(window).width(); - CHANGED to avoid reflows.
  window.wh = document.documentElement.clientHeight; //$(window).height(); - CHANGED to avoid reflows.
  window.hh = $("header").outerHeight();

  // Check if we are in Mobile (ie Responsive mode)
  if ($('.hamburger').is(":visible")) {
    is_responsive = true;
  } else {
    is_responsive = false;
  }

  // padding to match fixed header height
  if ($header && $header.length && is_responsive) {
    $("#wrapper").css({
      paddingTop: hh + "px"
    });
  } else {
    $("#wrapper").css({
      paddingTop: 0
    });
  }
  refreshScrollData(); // refresh scroll data just in case...
  refreshForcedWidthContainers();
}

/****************************************************************************************************/
/* Document Ready */
/****************************************************************************************************/

window.addEventListener('DOMContentLoaded', function () {
  $header = $("#header");
  refreshDimensions();
  $(window).trigger('resize');
});

/****************************************************************************************************/
/* Sticky Header */
/****************************************************************************************************/

window.addEventListener('DOMContentLoaded', function () {
  if ($(".topHeader").length && !window.is_responsive) {
    var stickyheader = new Waypoint.Sticky({
      element: $('.topHeader')[0]
    });
  }
  if ($(".jumpMenu").length) {
    var sticky = new Waypoint.Sticky({
      element: $('.jumpMenu')[0]
    });
  }
});

/****************************************************************************************************/
/* Scroll Events */
/****************************************************************************************************/

var mainScrollEvent = function () {
  $header = $("#header");
  refreshScrollData();

  // Scroll-to-top link
  if (lastScrollTop > 450) {
    $('.scrollToTop').fadeIn();
  } else {
    $('.scrollToTop').fadeOut();
  }
  $header.removeClass("down up").addClass(window.scrollDirection);
  if (lastScrollTop === 0) {
    $header.addClass("top");
  } else {
    $header.removeClass("top");
  }
};

// optimized event handler: https://web.dev/uses-passive-event-listeners/
document.addEventListener('scroll', mainScrollEvent, {
  passive: true
});
var hasRunCountUpAnimation = false;

/****************************************************************************************************/
/* Scroll to location on page */
/****************************************************************************************************/

window.addEventListener('DOMContentLoaded', function () {
  function scrollToLocation(scrollTo, animate, speed) {
    speed = typeof speed !== 'undefined' ? speed : 500;
    animate = typeof animate !== 'undefined' ? animate : true;
    scrollTo = $(scrollTo);
    var container = $('html, body');
    if (animate) {
      container.animate({
        scrollTop: scrollTo.offset().top - container.offset().top + container.scrollTop()
      }, speed);
    } else {
      // Required so that element on page is loaded
      setTimeout(function () {
        container.scrollTop(scrollTo.offset().top - container.offset().top + container.scrollTop());
      }, 250);
    }
  }
});
$(document).on('click', '.scrollToTop', function () {
  $('html, body').animate({
    scrollTop: 0
  }, 800);
  return false;
});

/****************************************************************************************************/
/* Window Resizing */
/****************************************************************************************************/

$(window).on('resize', function () {
  refreshDimensions();
});

/****************************************************************************************************/
/* Containers */
/****************************************************************************************************/

function refreshScrollbarWidthValue() {
  var scrollbarWidth = 16; // px (standard measured manually on Chrome)
  try {
    scrollbarWidth = getScrollbarWidth();
  } catch {
    console.log("unable to calculate scrollbar width automatically.");
  }
}
function getTopLevelScrollBarWidth() {
  var scrollbarWidth = 0;
  if (document.body.scrollHeight > document.body.clientHeight || document.documentElement.scrollHeight > document.documentElement.clientHeight) {
    scrollbarWidth = getScrollbarWidth();
  }
  return scrollbarWidth;
}

/* Updates the max-width of edge-to-edge containers to account for scrollbars */
function refreshForcedWidthContainers() {
  //var scrollbarWidth = 16; // px (standard measured manually on Chrome)
  //try {
  //    scrollbarWidth = getScrollbarWidth();
  //    console.log({ scrollbarWidth });
  //}
  //catch {
  //    console.log("unable to calculate scrollbar width automatically.");
  //}
  var scrollbarWidth = getTopLevelScrollBarWidth();
  var width = "calc(100vw - " + scrollbarWidth + "px)";
  var $forcedWidthContainers = $(".container.edge, .container.force");
  $forcedWidthContainers.each(function () {
    $(this).css({
      //width: width,
      maxWidth: "100vw"
    });
  });
  //$edgeWidthContainers.each(function () {
  //    $(this).css({
  //        //width: width,
  //        maxWidth: "100vw"
  //    });
  //});
  // ToDo: try doing this with a custom property instead:
  let root = document.documentElement;
  root.style.setProperty('--scrollbar-width', scrollbarWidth + "px");
}
function getScrollbarWidth() {
  //debugger;

  // Creating invisible container
  const outer = document.createElement('div');
  outer.style.visibility = 'hidden';
  outer.style.overflow = 'scroll'; // forcing scrollbar to appear
  outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
  document.body.appendChild(outer);

  // Creating inner element and placing it in the container
  const inner = document.createElement('div');
  outer.appendChild(inner);

  // Calculating difference between container's full width and the child width
  const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

  // Removing temporary elements from the DOM
  outer.parentNode.removeChild(outer);
  return scrollbarWidth;
}

/****************************************************************************************************/
/* Hyperlinks */
/****************************************************************************************************/

// Show a warning message / disclaimer when clicking on an email link
window.addEventListener('DOMContentLoaded', function () {
  $('a[href^="mailto"]').on("click", function () {
    return confirm("Sending an e-mail to us will not make us your lawyers.  Please do not include any confidential information in your e-mail.");
  });
});

// Dynamically add the appropriate aria-describedby reference to links
window.addEventListener('DOMContentLoaded', function () {
  if (!isSitefinityEditor()) {
    // only run this on the front-end to prevent the changes from accidentally getting saved into the post
    updateDynamicHyperlinkStylesAndAttributes();
  }
});
function updateDynamicHyperlinkStylesAndAttributes() {
  $(".cmsContent a, .sf-Long-text a").each(function () {
    var hyperlinkUrl = $(this).attr("href");
    var linkOpensInNewTab = $(this).attr("target") && $(this).attr("target") === "_blank";
    if (isExternalUrl(hyperlinkUrl)) {
      if (linkOpensInNewTab) {
        // opens an external link in a new tab
        $(this).attr("aria-describedby", "new-window-2").attr("rel", "noopener");
      } else {
        // opens an external link
        $(this).attr("aria-describedby", "new-window-1").attr("rel", "noopener");
      }
    } else if (linkOpensInNewTab) {
      // opens link in a new tab
      $(this).attr("aria-describedby", "new-window-0").attr("rel", "noopener");
    }
  });
}
window.destinationUrl = ""; // holds the url of the last link clicked

// store the destination url to be used for page loading animation logic
$(document).on("click", "a[href]", function (event) {
  window.destinationUrl = $(this).attr("href");
});

/****************************************************************************************************/
/* Sliders / Carousels */
/****************************************************************************************************/

/*
 Global splide config. These 
 */
window.globalSplideConfig = {
  type: 'loop'
  //start: 0,
  //perPage: 1,
  //perMove: 1,
  //pagination: true,
  //arrows: false,
  //autoHeight: true,
  //rewind: false,
  //speed: '500',
  //autoplay: true,
  //easing: 'cubic-bezier(.12,.8,.47,.98)',
  //accessibility: true,
  //classes: {
  //    //arrows: 'splide__arrows your-class-arrows',
  //    //arrow: 'splide__arrow your-class-arrow',
  //    prev: 'splide__arrow--prev fas fa-chevron-left',
  //    next: 'splide__arrow--next fas fa-chevron-right',
  //},
};

// Slider presets. These get merged with the globalSplideConfig options to configure ALL splide sliders throughout the site.
window.SplideConfigurations = [/* Default configuration */
{
  name: "default",
  //start: 0,
  type: 'loop',
  perPage: 3,
  perMove: 1,
  breakpoints: {
    1024: {
      perPage: 2
    },
    640: {
      perPage: 1
    }
  },
  variants: [{
    // config that inherits/overrides a parent config
    name: "default-no-dots",
    dots: false
  }]
}, /* Homeslideshow / Hero */
{
  name: "hero",
  autoplay: true,
  speed: '1000',
  interval: '10000',
  type: 'loop',
  arrows: true,
  start: 0,
  perPage: 1,
  perMove: 1
}, /* Homeslideshow / Hero */
{
  name: "insights",
  type: 'loop',
  perPage: 2,
  perMove: 2,
  dots: false,
  grid: {
    dimensions: [[2, 1], [1, 1], [2, 1], [1, 1], [2, 1], [1, 1]],
    gap: {
      row: '0px',
      col: '0px'
    }
  },
  breakpoints: {
    1024: {
      grid: false,
      perPage: 3,
      perMove: 3,
      arrows: false
    },
    600: {
      grid: false,
      perPage: 1,
      perMove: 1
    }
  }
}, /* Single Slide Resources */
{
  name: "single",
  type: 'loop',
  start: 0,
  perPage: 1,
  perMove: 1
}, /* Fade */
{
  name: "fade",
  type: 'fade',
  start: 0,
  perPage: 1,
  perMove: 1
}];

/* Get a splide configration matching a given name */
window.getSplideConfiguraion = function (splideConfigurationName = "default") {
  let mergedConfiguration = {};
  for (var configuration of window.SplideConfigurations) {
    if (configuration.name === splideConfigurationName) {
      mergedConfiguration = Object.assign({}, configuration);
      break;
    } else if (configuration.hasOwnProperty("variants") && configuration.variants.length) {
      for (var variant of configuration.variants) {
        if (variant.name === splideConfigurationName) {
          mergedConfiguration = Object.assign({}, configuration, variant);
          // remove unneeded properties
          delete mergedConfiguration.variants;
          //delete mergedConfiguration.name;
          break;
        }
      }
    }
  }
  mergedConfiguration = Object.assign({}, window.globalSplideConfig, mergedConfiguration);
  // console.log(splideConfigurationName, mergedConfiguration);
  return mergedConfiguration;
};

/* Loop through our widget / view sliders and initiate them using their preset configs */
var splideSliders = [];
$(".splide[data-splide-preset]").not(".is-active").each(function (i, el) {
  let $slider = $(this);
  let configurationName = $slider.attr("data-splide-preset");
  let configuration = getSplideConfiguraion(configurationName);
  let splide = new Splide($slider[0], configuration);
  //splide.on("mounted", function () {
  // console.log("mounted", splide);
  //});
  splideSliders.push(splide);
  splide.on('mounted', function () {
    // if fewer slides than provided in options, set option to the number of slides
    if (splide.length <= splide.options.perPage) {
      splide.options.perPage = splide.length;
    }
  });
  splide.mount({
    Grid
  });
});

/* fix for banner resizing */
$(window).on("resize", function () {
  for (var i = 0; i < splideSliders.length; i++) {
    splideSliders[i].refresh();
  }
});

/****************************************************************************************************/
/* Search Box */
/****************************************************************************************************/

//$(function () {
//    var searchWrapper = $('.sfsearchBox');
//    var searchInput = searchWrapper.find('input[name="search"]');
//    var searchIndex = searchWrapper.find('input[id="hdnSearchIndex"]');
//    var searchLocation = searchWrapper.find('input[id="hdnSearchLocation"]');
//    var searchButton = searchWrapper.find('button');

//    searchButton.click(function (e) {
//        e.preventDefault();

//        var index = searchIndex.val();
//        var value = searchInput.val().trim();
//        var location = searchLocation.val().trim();
//        if (index && value !== '' && location !== '') {
//            window.location = location
//                + '?indexCatalogue='
//                + index + '&searchQuery='
//                + value + '&wordsMode=0';
//        }
//    });

//    searchInput.keypress(function (e) {
//        var key = e.which;

//        // the enter key code
//        if (key === 13) {
//            searchButton.click();
//            return false;
//        }
//    });
//});

/****************************************************************************************************/
/* Facts / Counters */
/****************************************************************************************************/

const el = document.querySelector('.counter');

// Start counting, do this on DOM ready or with Waypoints.
//counterUp(el, {
//    duration: 1000,
//    delay: 16,
//});

window.addEventListener('DOMContentLoaded', function () {

  //var $counters = $('.counter');
  //if ($counters.length) {
  //    $counters.each(function (i, counter) {
  //        // No need to call waypoints manually ... the counter-up plugin has the call built-in
  //        $(counter).counterUp({
  //            delay: 20,
  //            time: 2000
  //        });
  //    });
  //}
});

/****************************************************************************************************/
/* Lazy Loading Images : http://jquery.eisbehr.de/lazy/ */
/****************************************************************************************************/

$('.lazy').lazy({
  threshold: 0 // images will load when 100 px from viewport edge
});

// Needed for lazy loading in some sliders to load images on click/swipe of next slide
function scrollUpDown1px() {
  setTimeout(function () {
    $(window).scrollTop($(window).scrollTop() - 1);
    $(window).scrollTop($(window).scrollTop() + 1);
  }, 250);
}

/****************************************************************************************************/
/* Forms / Autofill */
/****************************************************************************************************/

// SEARCH BOX - PLACEHOLDER TEXT
$('.search input[type="text"]').attr("placeholder", "How Can We Help You?");

// Fix for Chrome Form Autofill for our contact form
$(".contactForm input[name*=Name]").attr('autocomplete', 'name');
$(".contactForm input[name*=Email]").attr('autocomplete', 'email');
$(".contactForm input[name*=Phone]").attr('autocomplete', 'tel');
// Or you could turn it off
//$('form').attr('autocomplete', 'off');

/****************************************************************************************************/
/* Misc */
/****************************************************************************************************/

// check if we're running inside the SF Page editor
function isSitefinityEditor() {
  return $("body").hasClass("sfPageEditor") || typeof sitefinity === "object";
}

// Check if a link is relative to the current base URL
function isRelativeUrl(url) {
  var regex = new RegExp('^(?:[a-z]+:)?//', 'i');
  return regex.test(url);
}

// check if a given URL is external (or different from the current one at least)
function isExternalUrl(url) {
  var match = url.match(/^([^:\/?#]+:)?(?:\/\/([^\/?#]*))?([^?#]+)?(\?[^#]*)?(#.*)?/);
  if (typeof match[1] === "string" && match[1].length > 0 && match[1].toLowerCase() !== location.protocol) return true;
  if (typeof match[2] === "string" && match[2].length > 0 && match[2].replace(new RegExp(":(" + {
    "http:": 80,
    "https:": 443
  }[location.protocol] + ")?$"), "") !== location.host) return true;
  return false;
}
$.fn.isHScrollable = function () {
  return this[0].scrollWidth > this[0].clientWidth;
};
$.fn.isVScrollable = function () {
  return this[0].scrollHeight > this[0].clientHeight;
};
$.fn.isScrollable = function () {
  return this[0].scrollWidth > this[0].clientWidth || this[0].scrollHeight > this[0].clientHeight;
};

// Expand Expertise section (Home Page)
$(".btnExpandExpertise").on("click", function () {
  $(".expertiseExpandable").slideToggle({
    duration: 300,
    easing: "swing"
  });
});

// Clickable items (e.g. a clickable article card with nested links)
$(document).on("click", ".clickable", function (event) {
  var $this = $(this);

  // If there's not data-url, then find the first child el with an href and use that
  var itemUrl = "";
  var target = "_self"; // default

  // First check for data atts. If none, use the first child link
  if (typeof $this.data("url") !== 'undefined' && $this.data("url").length) {
    itemUrl = $this.data("url");
    if (typeof $this.data("target") !== 'undefined' && $this.data("target").length) {
      target = $this.data("target");
    }
  } else {
    var $firstLinkFound = $this.find("a[href]").first();
    itemUrl = $firstLinkFound.attr("href");
    target = $firstLinkFound.attr("target") ? $firstLinkFound.attr("target") : target;
  }
  window.open(itemUrl, target);
});

/****************************************************************************************************/
/* Accordions */
/****************************************************************************************************/

var groupClass = "group";
var expandedClass = "active";
window.addEventListener('DOMContentLoaded', function () {
  var $accordions = $(".accordion"); //.not(".disabled");
  if ($accordions.length && !isSitefinityEditor()) {
    // Add accessibility attributes
    updateAccordionAccessibilityAtts();

    // Add expand/collapse all button to first accordion
    //$accordions = $(".accordion");
    //if ($accordions.length > 1) {
    //    $("<div class='btnExpandAll expand'>Expand All</div>").prependTo($accordions.first());
    //    $accordions.first().addClass("hasExpandAll");
    //}
    // ToDo: Find a better way of adding the expand/collapse all button without making the <dl> markup invalid

    // Expand first 
    if ($(".accordion." + expandedClass).length) {
      expandAccordion($(".accordion." + expandedClass).first());
    }

    // Open all accordions with the "active" class
    $(".accordion.active").each(function () {
      var $accordion = $(this);
      expandAccordion($accordion);
    });

    // Click & Keypress handlers
    $(".accordion .accordionTop").on("click", function (ev) {
      toggleAccordion($(this).parent(".accordion"));
    }).on("keypress", function (ev) {
      if (ev.which === 13) {
        // enter key code
        toggleAccordion($(this).parent(".accordion"));
      }
    });

    // Expand / Collapse All accordions
    $(".btnExpandAll").on("click", function () {
      //debugger;
      var $button = $(this);
      if ($button.hasClass("expand")) {
        $accordions.each(function () {
          expandAccordion($(this)); // expand each accordion
        });
        updateExpandAllButton();
      } else {
        $accordions.each(function () {
          collapseAccordion($(this)); // close each accordion
        });
        updateExpandAllButton();
      }
    });
  }

  ///horizontal
  var panel = $('.at-accordion__panel');
  panel.click(function () {
    // console.log('click');
    panel.removeClass('is-open');
    $(this).addClass('is-open');
  });
});
function updateAccordionAccessibilityAtts() {
  // Make sure they're tab navigable/focusable
  $(".accordion").each(function (i, el) {
    var $accordion = $(el);
    var $accordionTop = $accordion.find(".accordionTop");
    var $accordionBottom = $accordion.find(".accordionBottom");
    if ($accordionTop.length && $accordionBottom.length) {
      // make sure accordionBottoms have unique Ids
      var accordionTopId = $accordionTop.uniqueId().attr("id");
      var accordionBottomId = $accordionBottom.uniqueId().attr("id");

      // make accodions focusable
      $accordionTop.attr("tabindex", "0");
      $accordionTop.attr("role", "button");
      var accordionTitle = $accordionTop.text().trim();
      if (!$accordionTop[0].hasAttribute("aria-label") && $accordionTop.attr("aria-label") !== "") {
        $accordionTop.attr("aria-label", accordionTitle);
        $accordionBottom.attr("aria-labeledby", accordionTopId);
        $accordionTop.attr("aria-controls", accordionBottomId);
        if ($accordionTop.is(".active")) {
          $accordionTop.attr("aria-expanded", "true");
          $accordionBottom.attr("aria-hidden", "false");
        } else {
          $accordionTop.attr("aria-expanded", "false");
          $accordionBottom.attr("aria-hidden", "true");
        }
      }
    }
  });
}

// Update the expand button to reflect current state of accordions
function updateExpandAllButton() {
  var $button = $(".btnExpandAll");
  var $accordions = $(".accordion");
  var $activeAccordions = $accordions.filter(".active");
  if ($button.length && $accordions.length > $activeAccordions.length) {
    // if some are open (but not all) then set to expand
    $button.addClass("expand");
    $button.text("Expand All");
  } else {
    $button.removeClass("expand");
    $button.text("Collapse All");
  }
}

// Toggle the target accordion
function toggleAccordion($accordion) {
  if ($accordion.hasClass(expandedClass)) {
    collapseAccordion($accordion);
  } else {
    closeGroupMembers($accordion); // close group members first
    expandAccordion($accordion);
  }
  updateExpandAllButton();
}

// Expand single accordion (and upate group)
function expandAccordion($accordion) {
  $accordion.addClass(expandedClass);
  $accordion.find(".accordionTop").addClass(expandedClass);
  $accordion.find(".accordionTop").attr("aria-expanded", "true");
  $accordion.find(".accordionBottom").addClass(expandedClass).slideDown();
  $accordion.find(".accordionBottom").attr("aria-hidden", "false");
  $accordion.find(".accordionBottom").prop("hidden", false);
  updateExpandAllButton();
}

// Close single accordion (and upate group)
function collapseAccordion($accordion) {
  $accordion.removeClass(expandedClass);
  $accordion.find(".accordionTop").removeClass(expandedClass);
  $accordion.find(".accordionTop").attr("aria-expanded", "false");
  $accordion.find(".accordionBottom").removeClass(expandedClass).slideUp();
  $accordion.find(".accordionBottom").attr("aria-hidden", "true");
  $accordion.find(".accordionBottom").prop("hidden", true);
  updateExpandAllButton();
}

// Check if accordion in group. If so, update group members
function closeGroupMembers($accordion) {
  var classes = $accordion[0].className.trim().split(/ |\t|\|/); // get array of classes (regex to account for space, tab, and pipe separators)
  var groups = $.grep(classes, function (classes, i) {
    // get only the classes containing groupClass
    return classes.indexOf(groupClass) === 0;
  });
  $.each(groups, function (i, group) {
    $(".accordion." + group).each(function () {
      collapseAccordion($(this)); // close each grouped accordion
    });
  });
}

/****************************************************************************************************/
/* Toggle Container / Expandable Content */
/****************************************************************************************************/
/* - these are LIKE accordions, but don't always have the same features or require the same markup. */
/* - Intended for more general purpose expand / collapse functionality) */
/****************************************************************************************************/

// Toggle Sections
window.addEventListener('DOMContentLoaded', function () {
  var expandedClass = "active";
  $(".toggleAction").on("click", function () {
    toggleContent($(this).next(".toggleContent"));
    return false;
  }).on("keypress", function (e) {
    if (e.which === 13) {
      // enter key code
      toggleContent($(this).next(".toggleContent"));
      return false;
    }
  });

  // Open the First
  //$(".toggleAction").first().trigger('click');

  // Toggle the Content
  function toggleContent($toggleSection) {
    if ($toggleSection.parent().hasClass(expandedClass)) {
      collapseToggleContent($toggleSection);
    } else {
      //updateGroup($toggleSection);
      expandToggleContent($toggleSection);
    }
  }
  function updateGroup($toggleSection) {
    var groupName = $toggleSection.parent().attr("data-accordion-group");
    if (groupName) {
      $("[data-accordion-group='" + groupName + "']").each(function () {
        collapseToggleContent($(this).find(".toggleContent"));
      });
    }
  }
  function expandToggleContent($toggleSection) {
    $toggleSection.parent().addClass(expandedClass);
    $toggleSection.slideDown();
  }

  // Close single accordion (and update group)
  function collapseToggleContent($toggleSection) {
    $toggleSection.parent().removeClass(expandedClass);
    $toggleSection.slideUp();
  }
});

// Jump Menu
// Takes a list of h2s and creates a jump menu 
// Requires an empty ul with class of .jumpMenu

window.addEventListener('DOMContentLoaded', function () {
  $(".jumpMenuWrapper aside h2, .jumpMenuWrapper h2.jump").each(function () {
    addScrollMenu($(this).html(), $(this));
  });
});
function addScrollMenu(name, sectionName) {
  var anchor = name.replace(/ /g, '');
  $(".jumpMenu").append("<li><a href='#" + anchor + "'>" + name.replace('<br>', ' ') + "</a></li>");
  $(sectionName).prepend("<a name='" + anchor + "'>");
}

//$(window).scroll(function () {
//    var position = $(this).scrollTop();

//    $('.jumpMenuWrapper aside h2 a, .jumpMenuWrapper h2.jump a').each(function () {
//        var target = $(this).offset().top;
//        var id = $(this).attr('name').replace(/ /g, '');
//        if (position >= target) {
//            $('.jumpMenu > ul > li > a').addClass('active');
//            $('.jumpMenu > ul > li > a[href$=\\#' + id + ']').addClass('active');
//        }
//    });
//});

$(".fraudAlertWrapper button").click(function () {
  $(".fraudAlertWrapper").addClass("hideThis");
});
AOS.init();